import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import moment from "moment"
import _isEmpty from "lodash/isEmpty"
import isInclusivelyBeforeDay from "react-dates/lib/utils/isInclusivelyBeforeDay"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../../../components/Typograph"
import SingleDate from "../../../../../../components/SingleDatePicker"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput/index"

import styles from "./styles.css"

import { time } from "services/utils/mask"
import { formatDateOrTime } from "../../../../helpers"

moment.locale("pt-br")

const StepSchedule = ({
  isCurrentStep,
  onNextStep,
  onPreviousStep,
  onClose,
  t,
  schedule,
  update,
  customer,
  saveOperation,
  hours
}) => {
  const [period, setPeriod] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: ""
  })

  const [disableStartDate, setDisableStartDate] = useState(false)

  const disabledButton =
    _isEmpty(period.startDate) ||
    _isEmpty(period.endDate) ||
    _isEmpty(period.startTime) ||
    _isEmpty(period.endTime)

  useEffect(() => {
    getPeriod()
  }, [])

  const handleChangePeriod = (e, type, mask) => {
    const value = e && e.target ? e.target.value : e

    setPeriod((prevState) => ({
      ...prevState,
      [type]: mask ? mask(value) : value
    }))
  }

  const getPeriod = () => {
    const startDate = formatDateOrTime(schedule.loadRedirect.startDate)
    const startTime = formatDateOrTime(schedule.loadRedirect.startDate, true)
    const endDate = formatDateOrTime(schedule.loadRedirect.endDate)
    const endTime = formatDateOrTime(schedule.loadRedirect.endDate, true)

    setPeriod({
      startDate,
      endDate,
      startTime,
      endTime
    })

    setDisableStartDate(
      schedule.loadRedirect.startDate &&
        !moment().isBefore(schedule.loadRedirect.startDate)
    )
  }

  const formatPeriod = () => {
    const { startDate, startTime, endDate, endTime } = period
    const { loadRedirect } = schedule

    if (startDate && startTime && endDate && endTime) {
      const formatStartDate =
        moment(startDate).format("YYYY-MM-DD") +
        " " +
        moment(startTime, "HH:mm").format("HH:mm:ssZZ")

      const formatEndDate =
        moment(endDate).format("YYYY-MM-DD") +
        " " +
        moment(endTime, "HH:mm").format("HH:mm:ssZZ")
      const scheduling = {
        ...loadRedirect,
        startDate: formatStartDate,
        endDate: formatEndDate
      }

      update(scheduling, true)
    }
  }

  const handlePrevStep = () => {
    onPreviousStep()
  }

  const handleNextStep = () => {
    formatPeriod()

    saveOperation(
      customer,
      "",
      "INTERFACE_ONLINE",
      "CONFIGURACAO",
      "SUCCESS",
      "",
      "Interface online"
    )
    onClose()
    onNextStep()
  }
  const dayBlocked = (day) => isInclusivelyBeforeDay(day, period.startDate)

  return (
    <ModernModal
      customModalClass={styles.modalClass}
      isOpen={isCurrentStep}
      onClose={onClose}
      onCancel={handlePrevStep}
      onConfirm={handleNextStep}
      cancelButtonText="Voltar"
      confirmButtonText="Prosseguir"
      disabled={disabledButton}
    >
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {t("START_CONFIG")}
      </Typograph>
      <Typograph
        htmlTag="h1"
        size="medium"
        color="outer_space"
        weight="semi-bold"
      >
        {schedule.loadRedirect.originPhoneNumber}
      </Typograph>
      <Typograph
        htmlTag="h1"
        size="medium"
        color="outer_space"
        weight="semi-bold"
      >
        Agendamento
      </Typograph>
      <Typograph htmlTag="p" size="medium" color="outer_space" weight="medium">
        Sua cota mensal é de 240 horas. Seu saldo até o final do mês corrente é
        de {hours} horas.
      </Typograph>

      <div
        className={classnames(styles.dateContainer, styles.startDateContainer)}
      >
        <span className={styles.infoDateClass}>Início</span>

        <SingleDate
          id="startDate"
          date={period.startDate}
          onDateChange={(e) => handleChangePeriod(e, "startDate")}
          openDirection="OPEN_UP"
          disabled={disableStartDate}
        />
        <span>às</span>
        <ModernFloatLabelInput
          label="Horário"
          id="startTime"
          margin="top_0"
          containerClasses={styles.containerClasses}
          onChange={(e) => handleChangePeriod(e, "startTime", time)}
          value={period.startTime}
          maxLength={5}
        />
      </div>
      <div className={styles.dateContainer}>
        <span className={styles.infoDateClass}>Término</span>
        <SingleDate
          id="endDate"
          date={period.endDate}
          onDateChange={(e) => handleChangePeriod(e, "endDate")}
          openDirection="OPEN_UP"
          isDayBlocked={dayBlocked}
        />
        <span>às</span>
        <ModernFloatLabelInput
          label="Horário"
          id="endTime"
          margin="top_0"
          containerClasses={styles.containerClasses}
          onChange={(e) => handleChangePeriod(e, "endTime", time)}
          value={period.endTime}
          maxLength={5}
        />
      </div>
    </ModernModal>
  )
}
StepSchedule.propTypes = {
  isCurrentStep: PropTypes.boolean,
  onNextStep: PropTypes.func,
  onPreviousStep: PropTypes.func,
  onClose: PropTypes.func,
  update: PropTypes.func,
  saveOperation: PropTypes.func,
  t: PropTypes.func,
  schedule: PropTypes.object,
  customer: PropTypes.object,
  hours: PropTypes.string
}
export default StepSchedule



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/StepModals/components/StepSchedule/index.js